  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    self.updateCart = function() {
      $s.showLoadingOverlay();
      $s.getJson({url: routes.root_url + '?sections=cart_content', success: async function(data){
        var section = document.querySelector('.cart-content');
        $s.updateDynamicContent(section, data['cart_content']);
        var summaryWrapper = document.querySelector('#cart .summary-column');
        if (section.querySelector('.cart-items')) {
          summaryWrapper.style.display = '';
        } else {
          summaryWrapper.style.display = 'none';
        }
        await $s.globalEval(data['cart_content']);
        $s.hideLoadingOverlay();
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        if (item && item.dataset.key) {
          data.updates[item.dataset.key] = quantity;
        }
      });
      postUpdate(data);
    }

    async function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.updateCartItemsQuantity(data).then(async function(cart) {var runResponse = await $s.AutoAddRemoveProducts.runAllRules(cart, true);self.updateCart();
      }).catch($s.addToCartFail);      
    }
  
  };
  //runs every time #cart div is replaced
  if (window.CartCache && CartCache.cart_fetch === null) {
    $s.get({url:'/cart.js'}); //trigger fetch to cache
  }
  var cart = document.getElementById('cart');
  var itemsCount = 0;
  cart.querySelectorAll('.cart-items .item').forEach(function(row){
    var isRelatedBundleItem = row.dataset.clbrtpsBundleItem && row.dataset.clbrtpsBundleItem.indexOf('clbrtps_bundle_related_') === 0;
    if (isRelatedBundleItem) return;

    var qtyInput = row.querySelector('.quantity-box input[type=number]');
    if (qtyInput) {
      itemsCount += qtyInput.value / 1;
    } else {
      // For main bundle items we hide the quantity input, but they always count as 1
      var isMainBundleItem = row.dataset.clbrtpsBundleItem === 'clbrtps_bundle_main';
      if (isMainBundleItem) {
        itemsCount += 1;
      }
    }
  });
  var cartCountElementCart = document.querySelectorAll('.cart-count');
  if(cartCountElementCart.length > 0) {
    cartCountElementCart.forEach(function(element){
      element.innerHTML = itemsCount;
    });
  }

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var row = this.closest('.item');
      if (row && row.dataset.clbrtpsBundleId && $s.updateClbrtpsBundleItemsQuantity) {
        $s.showLoadingOverlay();
        $s.updateClbrtpsBundleItemsQuantity(row.dataset.clbrtpsBundleId, 0).then(async function(cart) {await $s.AutoAddRemoveProducts.runAllRules(cart, true);CartPage.updateCart();
        }).catch($s.addToCartFail);
        return;
      }
      var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(row, 0) : [row];
      CartPage.updateItemsQuantity(items, 0);
    });
  });

  cart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(this.closest('.item'), this.value) : [this.closest('.item')];
      CartPage.updateItemsQuantity(items, this.value);
    });
  });

  
    
      document.querySelectorAll('.cart-accordion-button').forEach(function(item){
        item.addEventListener('click', ()=> {
          var panel = item.closest('.cart-custom').querySelector('.expandable');
          if (item.getAttribute('aria-expanded')=='false') {
            item.setAttribute('aria-expanded', 'true');
            $s.expand([panel]);
          } else {
            item.setAttribute('aria-expanded', 'false');
            $s.collapse([panel]);
          }
          return false;
        });
      });
    
  
  

  if ($s.validateBundlesInJson) {
    $s.getJson({url:'/cart.js'}).then(data=>{
      $s.validateBundlesInJson(data.items);
    })
  }
})();